import groupBy from 'lodash/groupBy'

import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    ContractBasisTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/ContractBasis/ContractBasis.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useHasPermission from 'app/hooks/useHasPermission'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import ContractBasisCreate from './ContractBasisCreate'
import ContractBasisCreateQuote from './ContractBasisCreateQuote'
import tableConfig from './ContractBasis.config'
import ContractBasisDetails from './ContractBasisDetails'
import AdditionalFees from './AdditionalFees'
import LaneGroups from './LaneGroups'
import LongTermLeaseFees from './LongTermLeaseFees'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const ContractBasisTable = () => {
    const contractBasisCreatePermission = useHasPermission(['contract_basis_create'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                url: ContractBasisTabs.ContractBasis,
                label: 'Contract Basis',
                Component: ContractBasisDetails,
                activeComparer: (pathname, tabUrl) => {
                    const pathnamesOccurrences = groupBy(pathname.split('/'))

                    if (pathnamesOccurrences[tabUrl]?.length >= 2) {
                        return true
                    }
                    return false
                },
            },
            permission: true,
        },
        {
            tab: {
                url: ContractBasisTabs.AdditionalFees,
                label: 'Additional Fees',
                Component: AdditionalFees,
                activeComparer: (pathname) => {
                    return pathname.split('/').includes(ContractBasisTabs.AdditionalFees)
                },
            },
            permission: true,
        },
        {
            tab: {
                url: ContractBasisTabs.LongTermLeaseFees,
                label: 'Long-term Lease Fees',
                Component: LongTermLeaseFees,
                activeComparer: (pathname) => {
                    return pathname.split('/').includes(ContractBasisTabs.LongTermLeaseFees)
                },
                condition: ({
                    isLongTermLease,
                }: { isLongTermLease?: boolean } = {}) => {
                    return isLongTermLease
                },
            },
            permission: true,
        },
        {
            tab: {
                url: ContractBasisTabs.LaneGroups,
                label: 'Lane Groups',
                Component: LaneGroups,
                activeComparer: (pathname) => {
                    return pathname.split('/').includes(ContractBasisTabs.LaneGroups)
                },
            },
            permission: true,
        },
        {
            tab: {
                url: ContractBasisTabs.CreateQuote,
                label: 'Create Quote',
                Component: ContractBasisCreateQuote,
            },
            permission: contractBasisCreatePermission,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: contractBasisCreatePermission ? ContractBasisCreate : undefined,
            }}
            name="ContractBasis"
            sidebarTabs={tabs}
            getDomainObject={requests.get}
            domainRequestKey={RequestKeys.getContractBasis}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>
    )
}

export default ContractBasisTable
